import { useEffect, useState } from "react";
import { GoogleSheetsForm } from "./components/GoogleSheetsForm";
import netlifyIdentity from "netlify-identity-widget";

export default function App() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    netlifyIdentity.init();
    
    if (netlifyIdentity.currentUser()) {
      setUser(netlifyIdentity.currentUser());
    }

    netlifyIdentity.on("login", (user) => {
      setUser(user);
      netlifyIdentity.close();
    });

    netlifyIdentity.on("logout", () => {
      setUser(null);
    });

  return() => {
    netlifyIdentity.off("login");
    netlifyIdentity.off("logout");
  };
  }, []);

  if (!user) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Please log in
        </h1>
        <button
          onClick={() => netlifyIdentity.open()}
          className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition"
        >
          Login
        </button>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Flynn Credit Submission Form
          </h1>
          <p className="text-gray-600">
            For support please reach out to your CSM: <a href="mailto:meghan.bulman@seasoned.co?subject=Seasoned Credit Request Form Support">Meghan Bulman</a>
          </p>
        </div>
        
        <GoogleSheetsForm user={user} />

        <div className="mt-8 text-center">
          <button
            onClick={() => netlifyIdentity.logout()}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 transition"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
